import { Timestamp } from "firebase/firestore";
import { AsyncStatus } from "../asyncState";
import {Product} from "./types";

export const DELETE_PRODUCT = 'DELETE_PRODUCT';

export const deleteProductAction = (products: Array<any>) => {
  return {
    type: 'DELETE_PRODUCT',
    payload: products,
  }
}

export const SAVE_RECEIVED_DATE = "SAVE_RECEIVED_DATE";

export const saveReceivedDateAction = (date: Timestamp) => {
  return {
    type: SAVE_RECEIVED_DATE,
    payload: date,
  };
};

/**
 * onSnapshotで使用する
 */
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const addProductAction = (product: Product) => {
  return {
    type: ADD_PRODUCT,
    payload: product,
  }
}

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const setProductsAction = (products: Product[]) => {
  return {
    type: SET_PRODUCTS,
    payload: products,
  }
}

/**
 * onSnapshotで使用する
 */
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const updateProductAction = (product: Product) => {
  return {
    type: UPDATE_PRODUCT,
    payload: product,
  }
}

/**
 * productのStatusを変更
 */
export const CHANGE_PRODUCT_STATUS = 'CHANGE_PRODUCT_STATUS'
export const changeProductStatus = (status: AsyncStatus) => {
  return {
    type: CHANGE_PRODUCT_STATUS,
    payload: status,
  }
}

export const RESET_RECEIVED_DATE = "RESET_RECEIVED_DATE";

export const resetReceivedDateAction = () => {
  return {
    type: RESET_RECEIVED_DATE,
    payload: ""
  };
};
